export default __webpack_public_path__ + "static/media/bg_6.be4c5eb7.jpg";